export default {
	ADESAO: 'adesaoProcessKey',
	ADESAO_EXTERNA: 'adesaoExternaProcessKey',
	PEDIDO: 'processoUtilizacaoProcessKey',
}
